// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assests/images/leaf.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-bg {
  min-height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.login-bg::after {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(44, 96, 53, 0.45);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  z-index: 0;
}

/* Main Card */
.login-container {
  display: flex;
  width: 700px;
  min-height: 400px;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.09);
  z-index: 1;
  position: relative;
}

/* Left Panel: Leaf image/logo */
/* .login-left {
  flex: 1 0 230px;
  background-color: rgba(255,255,255,0.76) !important;
  background: url('../../../assests/images/fmanlogo1.png');
  background-position: center;
  background-size: 400px auto;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
} */

/* .login-left {
  flex: 1 0 220px;
  background-color: rgba(255, 255, 255, 0.76) !important;
  display: flex;
  flex-direction: column;
 
  align-items: center;
  justify-content: center;
  gap: 0px;


}

.login-left img {
  max-width: 350px;

  height: auto;
}

.login-left img:nth-of-type(2) {
  max-width: 150px;

  height: auto;
} */

.login-left {
  flex: 1 0 220px;
  background-color: rgba(255, 255, 255, 0.76) !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* keeps main logo center + powered by bottom */
  align-items: center;
  padding: 20px 10px;
  position: relative;
}

.main-logo-container {
  flex: 1 1;
  display: flex;
  align-items: center;
  /* vertically center main logo */
  justify-content: center;
  /* horizontally center */
  width: 100%;
}

.main-logo {
  max-width: 300px;

  height: auto;
}

.powered-by {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  /* reduce gap between text and logo */
  margin-bottom: 15px;
}

.power {
  font-size: 14px;
  color: #333;
  margin: 0;
}

.powered-logo {

  max-width: 100px;

  height: auto;
  opacity: 0.9;
  /* optional subtle look */
}



.login-logo {
  width: 128px;
  height: 128px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 50%;
}

/* Right Panel: Login Form */
.login-right {
  flex: 2 1;
  background: rgba(255, 255, 255, 0.76);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 52px 38px;
  min-width: 320px;
}

.login-right h2 {
  text-align: left;
  font-size: 2rem;
  margin-bottom: 25px;
  font-weight: 700;
  color: #242422;
}

.input-group {
  display: flex;
  align-items: center;
  background: #f6f8f6;
  border-radius: 6px;
  margin-bottom: 18px;
  border: 1px solid #e0eadc;
  padding: 0 6px;
}

.input-icon {
  color: #95b37b;
  font-size: 1.2em;
  margin-right: 8px;
}

.input-group input {
  border: none;
  outline: none;
  background: transparent;
  flex: 1 1;
  padding: 12px 0;
  font-size: 1rem;
  color: #242422;
}

.input-group input::placeholder {
  color: #b5beab;
}

.login-options {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 18px;
}

.forgot-password {
  font-size: 0.91rem;
  color: #6c7d5f;
  text-decoration: none;
}

.forgot-password:hover {
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  padding: 12px 0;
  background: #7ba85c;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 1.07rem;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  letter-spacing: 1px;
}

.login-btn:hover {
  background: #5e7c44;
}

.resend-otp {
  margin-bottom: 20px;
}

.resend-btn {
  background: none;
  border: none;
  color: #4a90e2;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.resend-btn:disabled {
  color: grey;
  cursor: not-allowed;
}

/* OTP buttons layout */
.otp-actions {
  display: flex;
  gap: 10px;
}

.resend-otp {
  margin-bottom: 20px;
}

.resend-btn {
  background: none;
  border: none;
  color: #4a90e2;
  font-size: 14px;
  cursor: pointer;
  padding: 0;
}

.resend-btn:disabled {
  color: grey;
  cursor: not-allowed;
}

/* OTP buttons container: horizontal layout */
.otp-actions {
  display: flex;
  gap: 16px;
  /* Space between buttons */
  margin-top: 10px;
}

/* Make both OTP buttons take equal width */
.otp-actions .login-btn,
.otp-actions .cancel-btn {
  flex: 1 1;
  /* Each button fills 50% of container */
  min-width: 0;
  /* Prevent overflow issues */
  padding: 12px;
  font-size: 16px;
  border-radius: 6px;
  font-weight: 600;
  box-sizing: border-box;
}

/* Retain color styles from previous CSS */
.otp-actions .login-btn {
  background-color: #4a90e2;
  color: white;
  border: none;
  transition: background-color 0.3s;
}

.otp-actions .login-btn:hover:not(:disabled) {
  background-color: #357ABD;
}

.otp-actions .login-btn:disabled {
  background-color: #a0c5f6;
  cursor: not-allowed;
}

.otp-actions .cancel-btn {
  background-color: #27ae60;
  color: white;
  border: none;
  transition: background-color 0.3s;
}

.otp-actions .cancel-btn:hover {
  background-color: #219150;
}

/* --- Base styles remain unchanged --- */

/* Add these responsive styles at the end of your CSS file */

/* Medium devices / tablets */
@media (max-width: 768px) {
  .login-container {
    flex-direction: column;
    width: 90vw;
    min-height: auto;
  }

  .login-left,
  .login-right {
    flex: none;
    width: 100%;
  }

  .login-left {
    background-size: contain;
    background-position: center top;
    background-repeat: no-repeat;
    padding-top: 30px;
    min-height: 180px;
  }

  .login-right {
    padding: 32px 20px;
    min-width: auto;
  }

  .login-right h2 {
    font-size: 1.5rem;
    margin-bottom: 20px;
  }

  .input-group {
    margin-bottom: 15px;
  }

  .login-btn,
  .otp-actions .login-btn,
  .otp-actions .cancel-btn {
    font-size: 15px;
    padding: 10px 0;
  }
}

/* Small devices / phones */
@media (max-width: 480px) {
  .login-container {
    width: 95vw;
  }

  .login-left {
    background-size: 250px auto;
    min-height: 140px;
    padding-top: 20px;
  }

  .login-right {
    padding: 24px 15px;
  }

  .login-right h2 {
    font-size: 1.3rem;
    margin-bottom: 16px;
  }

  .input-group input {
    font-size: 0.9rem;
  }

  .input-icon {
    font-size: 1em;
    margin-right: 6px;
  }

  .login-btn,
  .otp-actions .login-btn,
  .otp-actions .cancel-btn {
    font-size: 14px;
    padding: 10px 0;
  }

  .otp-actions {
    gap: 12px;
  }
}

/* Optional: For very small devices (less than 360px) */
@media (max-width: 360px) {
  .login-left {
    background-size: 200px auto;
  }

  .login-right {
    padding: 20px 12px;
  }
}

.error-msg {
  display: block;
  color: #d9534f;
  /* bootstrap red */
  font-size: 0.875rem;
  margin: 5px;
  /* spacing from input */
}

.log-error {
  display: block;
  color: #d9534f;
  /* bootstrap red */
  font-size: 0.875rem;
  margin: 5px;
  /* spacing from input */
}`, "",{"version":3,"sources":["webpack://./src/pages/360View/360Login/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mDAAoD;EACpD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;EAC1B,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,UAAU;EACV,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;;;;;;;;;;GAUG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;GAuBG;;AAEH;EACE,eAAe;EACf,sDAAsD;EACtD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,+CAA+C;EAC/C,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;;EAEE,gBAAgB;;EAEhB,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;;;AAIA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,SAAY;EACZ,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,SAAO;EACP,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;;EAEE,SAAO;EACP,uCAAuC;EACvC,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;;AAEzC,4DAA4D;;AAE5D,6BAA6B;AAC7B;EACE;IACE,sBAAsB;IACtB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,wBAAwB;IACxB,+BAA+B;IAC/B,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;;;IAGE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,uDAAuD;AACvD;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;AACzB","sourcesContent":[".login-bg {\n  min-height: 100vh;\n  background: url('../../../assests/images/leaf.jpeg');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.login-bg::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: rgba(44, 96, 53, 0.45);\n  backdrop-filter: blur(2px);\n  z-index: 0;\n}\n\n/* Main Card */\n.login-container {\n  display: flex;\n  width: 700px;\n  min-height: 400px;\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.09);\n  z-index: 1;\n  position: relative;\n}\n\n/* Left Panel: Leaf image/logo */\n/* .login-left {\n  flex: 1 0 230px;\n  background-color: rgba(255,255,255,0.76) !important;\n  background: url('../../../assests/images/fmanlogo1.png');\n  background-position: center;\n  background-size: 400px auto;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n} */\n\n/* .login-left {\n  flex: 1 0 220px;\n  background-color: rgba(255, 255, 255, 0.76) !important;\n  display: flex;\n  flex-direction: column;\n \n  align-items: center;\n  justify-content: center;\n  gap: 0px;\n\n\n}\n\n.login-left img {\n  max-width: 350px;\n\n  height: auto;\n}\n\n.login-left img:nth-of-type(2) {\n  max-width: 150px;\n\n  height: auto;\n} */\n\n.login-left {\n  flex: 1 0 220px;\n  background-color: rgba(255, 255, 255, 0.76) !important;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  /* keeps main logo center + powered by bottom */\n  align-items: center;\n  padding: 20px 10px;\n  position: relative;\n}\n\n.main-logo-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  /* vertically center main logo */\n  justify-content: center;\n  /* horizontally center */\n  width: 100%;\n}\n\n.main-logo {\n  max-width: 300px;\n\n  height: auto;\n}\n\n.powered-by {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  /* reduce gap between text and logo */\n  margin-bottom: 15px;\n}\n\n.power {\n  font-size: 14px;\n  color: #333;\n  margin: 0;\n}\n\n.powered-logo {\n\n  max-width: 100px;\n\n  height: auto;\n  opacity: 0.9;\n  /* optional subtle look */\n}\n\n\n\n.login-logo {\n  width: 128px;\n  height: 128px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.11);\n  border-radius: 50%;\n}\n\n/* Right Panel: Login Form */\n.login-right {\n  flex: 2 1 0%;\n  background: rgba(255, 255, 255, 0.76);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 52px 38px;\n  min-width: 320px;\n}\n\n.login-right h2 {\n  text-align: left;\n  font-size: 2rem;\n  margin-bottom: 25px;\n  font-weight: 700;\n  color: #242422;\n}\n\n.input-group {\n  display: flex;\n  align-items: center;\n  background: #f6f8f6;\n  border-radius: 6px;\n  margin-bottom: 18px;\n  border: 1px solid #e0eadc;\n  padding: 0 6px;\n}\n\n.input-icon {\n  color: #95b37b;\n  font-size: 1.2em;\n  margin-right: 8px;\n}\n\n.input-group input {\n  border: none;\n  outline: none;\n  background: transparent;\n  flex: 1;\n  padding: 12px 0;\n  font-size: 1rem;\n  color: #242422;\n}\n\n.input-group input::placeholder {\n  color: #b5beab;\n}\n\n.login-options {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 18px;\n}\n\n.forgot-password {\n  font-size: 0.91rem;\n  color: #6c7d5f;\n  text-decoration: none;\n}\n\n.forgot-password:hover {\n  text-decoration: underline;\n}\n\n.login-btn {\n  width: 100%;\n  padding: 12px 0;\n  background: #7ba85c;\n  color: #fff;\n  border: none;\n  border-radius: 6px;\n  font-size: 1.07rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n  letter-spacing: 1px;\n}\n\n.login-btn:hover {\n  background: #5e7c44;\n}\n\n.resend-otp {\n  margin-bottom: 20px;\n}\n\n.resend-btn {\n  background: none;\n  border: none;\n  color: #4a90e2;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.resend-btn:disabled {\n  color: grey;\n  cursor: not-allowed;\n}\n\n/* OTP buttons layout */\n.otp-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.resend-otp {\n  margin-bottom: 20px;\n}\n\n.resend-btn {\n  background: none;\n  border: none;\n  color: #4a90e2;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 0;\n}\n\n.resend-btn:disabled {\n  color: grey;\n  cursor: not-allowed;\n}\n\n/* OTP buttons container: horizontal layout */\n.otp-actions {\n  display: flex;\n  gap: 16px;\n  /* Space between buttons */\n  margin-top: 10px;\n}\n\n/* Make both OTP buttons take equal width */\n.otp-actions .login-btn,\n.otp-actions .cancel-btn {\n  flex: 1;\n  /* Each button fills 50% of container */\n  min-width: 0;\n  /* Prevent overflow issues */\n  padding: 12px;\n  font-size: 16px;\n  border-radius: 6px;\n  font-weight: 600;\n  box-sizing: border-box;\n}\n\n/* Retain color styles from previous CSS */\n.otp-actions .login-btn {\n  background-color: #4a90e2;\n  color: white;\n  border: none;\n  transition: background-color 0.3s;\n}\n\n.otp-actions .login-btn:hover:not(:disabled) {\n  background-color: #357ABD;\n}\n\n.otp-actions .login-btn:disabled {\n  background-color: #a0c5f6;\n  cursor: not-allowed;\n}\n\n.otp-actions .cancel-btn {\n  background-color: #27ae60;\n  color: white;\n  border: none;\n  transition: background-color 0.3s;\n}\n\n.otp-actions .cancel-btn:hover {\n  background-color: #219150;\n}\n\n/* --- Base styles remain unchanged --- */\n\n/* Add these responsive styles at the end of your CSS file */\n\n/* Medium devices / tablets */\n@media (max-width: 768px) {\n  .login-container {\n    flex-direction: column;\n    width: 90vw;\n    min-height: auto;\n  }\n\n  .login-left,\n  .login-right {\n    flex: none;\n    width: 100%;\n  }\n\n  .login-left {\n    background-size: contain;\n    background-position: center top;\n    background-repeat: no-repeat;\n    padding-top: 30px;\n    min-height: 180px;\n  }\n\n  .login-right {\n    padding: 32px 20px;\n    min-width: auto;\n  }\n\n  .login-right h2 {\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n  }\n\n  .input-group {\n    margin-bottom: 15px;\n  }\n\n  .login-btn,\n  .otp-actions .login-btn,\n  .otp-actions .cancel-btn {\n    font-size: 15px;\n    padding: 10px 0;\n  }\n}\n\n/* Small devices / phones */\n@media (max-width: 480px) {\n  .login-container {\n    width: 95vw;\n  }\n\n  .login-left {\n    background-size: 250px auto;\n    min-height: 140px;\n    padding-top: 20px;\n  }\n\n  .login-right {\n    padding: 24px 15px;\n  }\n\n  .login-right h2 {\n    font-size: 1.3rem;\n    margin-bottom: 16px;\n  }\n\n  .input-group input {\n    font-size: 0.9rem;\n  }\n\n  .input-icon {\n    font-size: 1em;\n    margin-right: 6px;\n  }\n\n  .login-btn,\n  .otp-actions .login-btn,\n  .otp-actions .cancel-btn {\n    font-size: 14px;\n    padding: 10px 0;\n  }\n\n  .otp-actions {\n    gap: 12px;\n  }\n}\n\n/* Optional: For very small devices (less than 360px) */\n@media (max-width: 360px) {\n  .login-left {\n    background-size: 200px auto;\n  }\n\n  .login-right {\n    padding: 20px 12px;\n  }\n}\n\n.error-msg {\n  display: block;\n  color: #d9534f;\n  /* bootstrap red */\n  font-size: 0.875rem;\n  margin: 5px;\n  /* spacing from input */\n}\n\n.log-error {\n  display: block;\n  color: #d9534f;\n  /* bootstrap red */\n  font-size: 0.875rem;\n  margin: 5px;\n  /* spacing from input */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
